// removed by extract-text-webpack-plugin
module.exports = {"bookingTime":"WDPSwEEE2dD-XWbqlCQCW","blockTime":"_2Rtd124Y05esvPIkr9yU-I","card":"GaHaDYWtT9b6nBbT6soXC","times":"_1ZlNEBdnPr2zpu7DNwTvaI","borderBottom":"_3BhLBsqIAiMDgLDoDeKHdd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/BookingTime.scss
// module id = 1101
// module chunks = 0